/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import {
  CATEGORY_AGENCY_FEES,
  CATEGORY_CHARGE,
  CATEGORY_MANAGEMENT_FEES,
  CATEGORY_OTHER,
  CATEGORY_REFUND,
  CATEGORY_RENT,
  CATEGORY_RENTAL_CHARGE,
  CATEGORY_SECURITY_DEPOSIT
} from '../../enums/TransactionCategories.mjs'

function useTransactionCategoryOptions () {
  const intl = useIntl()
  return useMemo(() => {
    return [
      {
        label: intl.formatMessage({
          id: 'charge',
          defaultMessage: 'Charge'
        }),
        value: CATEGORY_CHARGE
      },
      {
        label: intl.formatMessage({
          id: 'rental_charge',
          defaultMessage: 'Charge locative'
        }),
        value: CATEGORY_RENTAL_CHARGE
      },
      {
        label: intl.formatMessage({
          id: 'security_deposit',
          defaultMessage: 'Dépôt de garantie'
        }),
        value: CATEGORY_SECURITY_DEPOSIT
      },
      {
        label: intl.formatMessage({
          id: 'agency_fees',
          defaultMessage: 'Frais d\'agence'
        }),
        value: CATEGORY_AGENCY_FEES
      },
      {
        label: intl.formatMessage({
          id: 'management_fees',
          defaultMessage: 'Honoraires de gestion'
        }),
        value: CATEGORY_MANAGEMENT_FEES
      },
      {
        label: intl.formatMessage({
          id: 'rent',
          defaultMessage: 'Loyer'
        }),
        value: CATEGORY_RENT
      },
      {
        label: intl.formatMessage({
          id: 'refund',
          defaultMessage: 'Remboursement'
        }),
        value: CATEGORY_REFUND
      },
      {
        label: intl.formatMessage({
          id: 'other',
          defaultMessage: 'Autre'
        }),
        value: CATEGORY_OTHER
      }
    ]
  }, [intl])
}

export default useTransactionCategoryOptions
